import type { FirebaseApp } from 'firebase/app'

import { initializeApp } from 'firebase/app'
import { getFirebaseConfig } from '../config'

const rawConfig = getFirebaseConfig()
const firebaseConfig = JSON.parse(rawConfig.firebaseConfig)

let app: FirebaseApp

export default function start() {
  // named Firebase app to isolate from host Firebase app
  // otherwise authentication token will be replaced and authentication will be broken
  app = initializeApp(firebaseConfig, 'experience')
}

export function getFirebaseApp() {
  return app
}
